export enum ScreenTypes {
  Intro = 'intro',
  Question = 'question',
  Explanation = 'explanation',
  End = 'end'
}
